import {isFilled} from '@prismicio/client'
import Link from 'next/link'
import {useLinkResolver} from 'prismicio'
import type {ResolvedCard} from 'slices/CustomerStoriesV2/resolveCardFromDocument'
import {Asset} from './Asset'
import {ContentSection} from './ContentSection'
import {SlideHeadlineSection} from './SlideHeadlineSection'

export const Slide = ({
  card,
  buttonLabel,
  enableReskin,
  index,
  pageUid,
  componentIndex,
}: {
  card: ResolvedCard
  buttonLabel?: string
  enableReskin?: boolean
  index: number
  pageUid?: string
  componentIndex?: number
}) => {
  const {linkResolver} = useLinkResolver()
  const slideHref = isFilled.link(card.primary_button_url) ? linkResolver(card.primary_button_url) : null

  return (
    <div className="group/slide relative flex h-full flex-col justify-between gap-y-6 p-6 md:flex-row lg:pl-12">
      {slideHref && <Link href={slideHref} className="absolute inset-0 z-10" aria-label={card.title} />}
      <div className="flex w-full flex-col justify-between gap-y-6 md:w-full md:py-2 md:pl-0 md:pr-10 lg:py-6">
        <SlideHeadlineSection tag={card.tag} title={card.title} />
        <ContentSection
          highlight_1_icon={card.highlight_1_icon}
          highlight_2_icon={card.highlight_2_icon}
          highlight_1_title={card.highlight_1_title}
          highlight_1_description={card.highlight_1_description}
          highlight_2_title={card.highlight_2_title}
          highlight_2_description={card.highlight_2_description}
          buttonLabel={buttonLabel}
          primary_button_url={card.primary_button_url}
          enableReskin={enableReskin}
          index={index}
          pageUid={pageUid}
          componentIndex={componentIndex}
        />
      </div>
      <Asset asset={card.image} />
    </div>
  )
}
